var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSavedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#8977A0",
    fillOpacity: 0.4,
    stroke: "#8977A0",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2384 5.85374L7.18385 12.9083C7.07839 13.0135 7.00924 13.1496 6.98645 13.2968L6.49295 16.5126C6.4763 16.6213 6.48545 16.7323 6.51966 16.8367C6.55387 16.9411 6.61219 17.036 6.68989 17.1137C6.76759 17.1914 6.86249 17.2497 6.96691 17.2839C7.07133 17.3181 7.18234 17.3273 7.29095 17.3106L10.5074 16.8171C10.6546 16.7945 10.7907 16.7256 10.8959 16.6204L17.9505 9.56584C18.0818 9.43457 18.1555 9.25655 18.1555 9.07094C18.1555 8.88532 18.0818 8.70731 17.9505 8.57604L15.2275 5.85304C15.0963 5.72202 14.9184 5.64844 14.733 5.64844C14.5476 5.64844 14.3697 5.72202 14.2384 5.85304V5.85374ZM8.02175 15.7825L8.33535 13.7357L14.7333 7.33774L16.4658 9.07094L10.0678 15.4689L8.02175 15.7825Z",
    fill: "#8977A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0093 8.67239L13.7513 7.92969L16.0207 10.1977L15.278 10.9404L13.0093 8.67239Z",
    fill: "#8977A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedIcon);
export default __webpack_public_path__ + "static/media/savedIcon.6e0d35f8d2a2a87872d0abbfc7eb4ecf.svg";
export { ForwardRef as ReactComponent };